import { Outlet } from "react-router-dom";
import SideBar from "../SideBar";
import Header from "../Header";
import Footer from "../Footer";

function AppTemplateLayout() {
  return (
    <div>
      <Header />
      {/* <SideBar /> */}
      <div>
        <Outlet />
      </div>
      <Footer />
    </div>
  );
}

export default AppTemplateLayout;
